let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cS1j1")).then(() => parcelRequire('7MhCX'));